import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';

function Spinner() {
  return (
    <div role="status" style={{ display: 'grid', placeItems: 'center', minHeight: '100vh', color: 'var(--text-faint)' }}>
      Cargando…
    </div>
  );
}

export function RequireAuth({ children }: { children: ReactNode }) {
  const { status } = useAuth();
  const loc = useLocation();
  if (status === 'loading') return <Spinner />;
  if (status === 'anon') return <Navigate to="/login" replace state={{ returnTo: loc.pathname }} />;
  return <>{children}</>;
}
